import React, { Component } from "react";
import { Spin, message, Alert, Popconfirm, Tag, Tooltip, Input } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import {
  CopyOutlined,
  CheckOutlined,
  DeleteOutlined,
  PlusOutlined,
  KeyOutlined,
  SafetyOutlined,
  RocketOutlined,
  ExclamationCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import ButtonItem from "../../../Components/ButtonItem";
import TableItem from "../../../Components/TableItem";
import ModalItem from "../../../Components/ModalItem";
import IconBiwo from "../../../Icons/IconBiwo";
import moment from "moment";
import "./ConfiguracionClaude.css";

function introKey(id) {
  return "biwoia_intro_" + (id || "x");
}

class ConfiguracionClaude extends Component {
  _timer = null;

  constructor(props) {
    super(props);
    let skipAnim = false;
    try {
      skipAnim = !!sessionStorage.getItem(introKey(props.empresaId));
    } catch (_) {}

    this.state = {
      // animation
      showAnim: !skipAnim,
      animPhase: 0, // 0=init, 1=icon, 2=biwo, 3=ia, 4=sub, 5=out
      // navigation
      vista: null, // null=grid, 'claude'=claude config
      // keys
      keys: [],
      loadingKeys: false,
      // modal nueva key
      modalNueva: false,
      nombreNueva: "",
      loadingGenerar: false,
      avisoNueva: null,
      // modal key generada
      keyGenerada: null,
      copiado: false,
    };
  }

  componentDidMount() {
    if (this.state.showAnim) {
      this._playAnimation();
    }
    this._cargarKeys();
  }

  componentWillUnmount() {
    if (this._timer) clearTimeout(this._timer);
  }

  _schedule(fn, ms) {
    this._timer = setTimeout(fn, ms);
  }

  _playAnimation() {
    // Phase 1: show icon (650ms)
    this._schedule(() => {
      this.setState({ animPhase: 1 });
      // Phase 2: biwo text (1200ms)
      this._schedule(() => {
        this.setState({ animPhase: 2 });
        // Phase 3: IA appears (1900ms)
        this._schedule(() => {
          this.setState({ animPhase: 3 });
          // Phase 4: subtitle (2700ms)
          this._schedule(() => {
            this.setState({ animPhase: 4 });
            // Phase 5: fade out (3800ms)
            this._schedule(() => {
              this.setState({ animPhase: 5 });
              // Remove (4900ms)
              this._schedule(() => {
                this.setState({ showAnim: false });
                try {
                  sessionStorage.setItem(introKey(this.props.empresaId), "1");
                } catch (_) {}
              }, 1100);
            }, 1100);
          }, 800);
        }, 700);
      }, 550);
    }, 300);
  }

  _skip = () => {
    if (this._timer) clearTimeout(this._timer);
    this.setState({ showAnim: false });
    try {
      sessionStorage.setItem(introKey(this.props.empresaId), "1");
    } catch (_) {}
  };

  _cargarKeys() {
    this.setState({ loadingKeys: true });
    axios
      .post("mcp-keys/listar", {}, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ keys: res.data.keys || [] });
        }
      })
      .catch(() => {})
      .finally(() => this.setState({ loadingKeys: false }));
  }

  _generarKey = () => {
    const nombre = this.state.nombreNueva.trim();
    if (!nombre) {
      message.warning("Escribe un nombre para la API key");
      return;
    }
    this.setState({ loadingGenerar: true, avisoNueva: null });
    axios
      .post(
        "mcp-keys/generar",
        { nombre },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            modalNueva: false,
            nombreNueva: "",
            keyGenerada: {
              id: res.data.id,
              nombre: res.data.nombre,
              key: res.data.key,
            },
          });
          this._cargarKeys();
        } else if (res.data.success === 1) {
          this.setState({ avisoNueva: res.data.message });
        } else {
          message.error("Error al generar la API key");
        }
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ loadingGenerar: false }));
  };

  _revocarKey = (id) => {
    axios
      .post("mcp-keys/revocar", { id }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success("API key revocada");
          this._cargarKeys();
        } else if (res.data.success === 1) {
          message.warning(res.data.message);
        } else {
          message.error("Error al revocar");
        }
      })
      .catch(() => message.error("Error de conexión"));
  };

  _copiar = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.setState({ copiado: true });
        setTimeout(() => this.setState({ copiado: false }), 2200);
      })
      .catch(() => message.error("No se pudo copiar"));
  };

  /* ===================== ANIMATION ===================== */
  renderAnimation() {
    const { animPhase } = this.state;
    return (
      <div
        className={"biwoia-anim" + (animPhase === 5 ? " biwoia-anim-out" : "")}
      >
        {/* Expanding rings */}
        <div className="biwoia-anim-rings">
          {[1, 2, 3, 4].map((n) => (
            <div key={n} className="biwoia-ring" />
          ))}
        </div>

        {/* Center stage */}
        <div className="biwoia-anim-stage">
          {/* Biwo hexagon icon */}
          <div
            className={
              "biwoia-anim-icon" +
              (animPhase >= 1 ? " biwoia-anim-icon-show" : "")
            }
          >
            <IconBiwo size={110} marginRight={0} color="#00BFD6" />
          </div>

          {/* Brand text: "biwo" + "IA" */}
          <div className="biwoia-anim-brand">
            <span
              className={
                "biwoia-anim-biwo" + (animPhase >= 2 ? " show" : "")
              }
            >
              biwo
            </span>

            <span
              className={
                "biwoia-anim-ia" + (animPhase >= 3 ? " biwoia-ia-show" : "")
              }
            >
              {/* Sparkles */}
              {animPhase >= 3 && (
                <>
                  <span className="biwoia-spark spark-1" />
                  <span className="biwoia-spark spark-2" />
                  <span className="biwoia-spark spark-3" />
                  <span className="biwoia-spark spark-4" />
                  <span className="biwoia-spark spark-5" />
                </>
              )}
              IA
            </span>
          </div>

          {/* Subtitle */}
          <p
            className={
              "biwoia-anim-sub" + (animPhase >= 4 ? " show" : "")
            }
          >
            Inteligencia Artificial para tu negocio
          </p>
        </div>

        <button className="biwoia-skip" onClick={this._skip}>
          Omitir
        </button>
      </div>
    );
  }

  /* ===================== PROVIDER GRID ===================== */
  renderGrid() {
    return (
      <div className="biwoia-page">
        <div className="biwoia-grid-page">
          {/* Header */}
          <div className="biwoia-grid-header">
            <IconBiwo size={44} marginRight={0} color="#00BFD6" />
            <h1 className="biwoia-grid-title">Biwo IA</h1>
          </div>
          <p className="biwoia-grid-subtitle">
            Elige tu asistente de inteligencia artificial y conecta tu ERP
          </p>

          <div className="biwoia-providers">
            {/* Claude card */}
            <div
              className="biwoia-provider-card"
              onClick={() => this.setState({ vista: "claude" })}
            >
              <div className="biwoia-claude-icon">C</div>
              <div>
                <p className="biwoia-provider-name">Claude</p>
                <p className="biwoia-provider-desc">
                  Modelo de lenguaje de Anthropic. Conecta tu ERP mediante el
                  protocolo MCP.
                </p>
              </div>
              <span className="biwoia-provider-tag">Disponible</span>
              <button className="biwoia-provider-cta">Configurar →</button>
            </div>

            {/* Placeholder: GPT */}
            <div className="biwoia-provider-card biwoia-card-soon">
              <span className="biwoia-soon-badge">Próximamente</span>
              <div
                className="biwoia-claude-icon"
                style={{ background: "#E0E0E0", boxShadow: "none" }}
              >
                <span style={{ fontSize: 22, color: "#AAA" }}>G</span>
              </div>
              <div>
                <p className="biwoia-provider-name" style={{ color: "#BBB" }}>
                  GPT
                </p>
                <p className="biwoia-provider-desc">OpenAI GPT-4o</p>
              </div>
            </div>

            {/* Placeholder: Gemini */}
            <div className="biwoia-provider-card biwoia-card-soon">
              <span className="biwoia-soon-badge">Próximamente</span>
              <div
                className="biwoia-claude-icon"
                style={{ background: "#E0E0E0", boxShadow: "none" }}
              >
                <span style={{ fontSize: 22, color: "#AAA" }}>G</span>
              </div>
              <div>
                <p className="biwoia-provider-name" style={{ color: "#BBB" }}>
                  Gemini
                </p>
                <p className="biwoia-provider-desc">Google Gemini 2.0</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ===================== CLAUDE CONFIG ===================== */
  renderClaudeConfig() {
    const {
      keys,
      loadingKeys,
      modalNueva,
      nombreNueva,
      loadingGenerar,
      avisoNueva,
      keyGenerada,
      copiado,
    } = this.state;

    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        render: (text) => (
          <span style={{ fontWeight: 600, color: "#002E36" }}>
            <KeyOutlined style={{ color: "#CC785C", marginRight: 8 }} />
            {text}
          </span>
        ),
      },
      {
        title: "Creada",
        dataIndex: "creadoEn",
        key: "creadoEn",
        render: (val) => (val ? moment(val).format("DD/MM/YYYY HH:mm") : "—"),
      },
      {
        title: "Último uso",
        dataIndex: "ultimoUso",
        key: "ultimoUso",
        render: (val) =>
          val ? (
            <Tag color="success">{moment(val).fromNow()}</Tag>
          ) : (
            <Tag>Nunca usada</Tag>
          ),
      },
      {
        title: "",
        key: "accion",
        width: 110,
        render: (_, record) => (
          <Popconfirm
            title="¿Revocar esta API key?"
            description="La integración que la usa dejará de funcionar."
            icon={<ExclamationCircleOutlined style={{ color: "#E53E3E" }} />}
            okText="Revocar"
            cancelText="Cancelar"
            okButtonProps={{ danger: true }}
            onConfirm={() => this._revocarKey(record._id)}
          >
            <ButtonItem danger size="small" icon={<DeleteOutlined />}>
              Revocar
            </ButtonItem>
          </Popconfirm>
        ),
      },
    ];

    return (
      <div className="biwoia-page">
        <div className="biwoia-claude-page">
          {/* Back */}
          <button
            className="biwoia-back"
            onClick={() => this.setState({ vista: null })}
          >
            <ArrowLeftOutlined />
            BIWO IA
          </button>

          {/* Connection banner */}
          <div className="biwoia-connect-banner">
            <h2 className="biwoia-connect-title">
              Cómo se conecta BIWO con Claude
            </h2>

            <div className="biwoia-connect-diagram">
              {/* BIWO node */}
              <div className="biwoia-diag-node">
                <div className="biwoia-diag-icon biwoia-diag-biwo">
                  <IconBiwo size={28} marginRight={0} color="white" />
                </div>
                <span className="biwoia-diag-label">BIWO ERP</span>
              </div>

              {/* Arrow */}
              <div className="biwoia-diag-arrow" />

              {/* MCP node */}
              <div className="biwoia-diag-node">
                <div className="biwoia-diag-icon biwoia-diag-mcp">
                  MCP
                </div>
                <span className="biwoia-diag-label">
                  Protocolo
                  <br />
                  de contexto
                </span>
              </div>

              {/* Arrow */}
              <div className="biwoia-diag-arrow" />

              {/* Claude node */}
              <div className="biwoia-diag-node">
                <div className="biwoia-diag-icon biwoia-diag-claude">
                  C
                </div>
                <span className="biwoia-diag-label">Claude AI</span>
              </div>
            </div>

            <p className="biwoia-connect-desc">
              BIWO expone sus datos y operaciones a través de un servidor MCP.
              Claude lo usa para consultar inventario, clientes, ventas y más —
              directamente desde tu conversación, sin copiar datos manualmente.
            </p>
          </div>

          {/* API Keys */}
          <div className="biwoia-card">
            <div className="biwoia-card-head">
              <div className="biwoia-card-title">
                <SafetyOutlined
                  style={{ color: "#00BFD6", marginRight: 10 }}
                />
                API Keys
              </div>
              <ButtonItem
                type="primary"
                icon={<PlusOutlined />}
                onClick={() =>
                  this.setState({ modalNueva: true, avisoNueva: null })
                }
                className="biwoia-btn-primary"
              >
                Nueva API Key
              </ButtonItem>
            </div>

            <Spin spinning={loadingKeys}>
              {keys.length === 0 && !loadingKeys ? (
                <div className="biwoia-empty">
                  <div className="biwoia-empty-icon">
                    <KeyOutlined />
                  </div>
                  <p className="biwoia-empty-text">
                    No tienes API keys activas aún.
                    <br />
                    Crea una para empezar a conectar Claude.
                  </p>
                </div>
              ) : (
                <TableItem
                  columns={columns}
                  dataSource={keys}
                  rowKey="_id"
                  pagination={false}
                  size="middle"
                />
              )}
            </Spin>
          </div>

          {/* Setup instructions */}
          <div className="biwoia-card biwoia-card-setup">
            <div className="biwoia-card-head">
              <div className="biwoia-card-title">
                <RocketOutlined
                  style={{ color: "#00BFD6", marginRight: 10 }}
                />
                Cómo conectar Claude
              </div>
            </div>

            <div className="biwoia-steps">
              <div className="biwoia-step">
                <div className="biwoia-step-num">1</div>
                <div className="biwoia-step-body">
                  <strong>Genera una API Key</strong>
                  <p>
                    Haz clic en "Nueva API Key", dale un nombre descriptivo
                    (p. ej. "Mi Laptop") y guarda la key — sólo se muestra una
                    vez.
                  </p>
                </div>
              </div>

              <div className="biwoia-step">
                <div className="biwoia-step-num">2</div>
                <div className="biwoia-step-body">
                  <strong>Claude Code (CLI / VS Code)</strong>
                  <p>
                    Agrega en <code>~/.claude/settings.json</code>:
                  </p>
                  <pre className="biwoia-code">{`{
  "mcpServers": {
    "biwo-erp": {
      "type": "http",
      "url": "https://TU_DOMINIO/mcp",
      "headers": {
        "Authorization": "Bearer biwo_TU_KEY"
      }
    }
  }
}`}</pre>
                </div>
              </div>

              <div className="biwoia-step">
                <div className="biwoia-step-num">3</div>
                <div className="biwoia-step-body">
                  <strong>Claude.ai (web / desktop)</strong>
                  <p>
                    Ve a{" "}
                    <strong>
                      Configuración → Integraciones → Agregar servidor MCP
                    </strong>{" "}
                    e ingresa:
                  </p>
                  <div className="biwoia-inline-row">
                    <span className="biwoia-row-label">URL:</span>
                    <code>https://TU_DOMINIO/mcp</code>
                  </div>
                  <div className="biwoia-inline-row">
                    <span className="biwoia-row-label">Header:</span>
                    <code>Authorization: Bearer biwo_TU_KEY</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Modal: Nueva key */}
          <ModalItem
            title={
              <span>
                <KeyOutlined style={{ color: "#CC785C", marginRight: 8 }} />
                Nueva API Key
              </span>
            }
            visible={modalNueva}
            onCancel={() =>
              this.setState({
                modalNueva: false,
                nombreNueva: "",
                avisoNueva: null,
              })
            }
            footer={null}
          >
            {avisoNueva && (
              <Alert
                type="warning"
                showIcon
                message={avisoNueva}
                style={{ marginBottom: 16, borderRadius: 8 }}
              />
            )}
            <p style={{ color: "#666", marginBottom: 12, fontSize: 14 }}>
              Asigna un nombre para identificar esta key (p. ej. "Oficina",
              "Mi Claude").
            </p>
            <Input
              placeholder="Nombre de la API key"
              prefix={<KeyOutlined style={{ color: "#CC785C" }} />}
              value={nombreNueva}
              onChange={(e) =>
                this.setState({ nombreNueva: e.target.value })
              }
              onPressEnter={this._generarKey}
              style={{ marginBottom: 16 }}
            />
            <ButtonItem
              type="primary"
              block
              loading={loadingGenerar}
              onClick={this._generarKey}
              className="biwoia-btn-primary"
              style={{ borderRadius: 8, height: 40, fontWeight: 600 }}
            >
              Generar API Key
            </ButtonItem>
          </ModalItem>

          {/* Modal: Key generada */}
          <ModalItem
            title="¡API Key generada!"
            visible={!!keyGenerada}
            onCancel={() =>
              this.setState({ keyGenerada: null, copiado: false })
            }
            footer={null}
          >
            <Alert
              type="warning"
              showIcon
              icon={<ExclamationCircleOutlined />}
              message="Guarda esta key ahora — no podrás verla de nuevo"
              style={{ marginBottom: 16, borderRadius: 8 }}
            />
            <div className="biwoia-key-box">
              <code className="biwoia-key-text">{keyGenerada?.key}</code>
              <Tooltip
                title={copiado ? "¡Copiado!" : "Copiar al portapapeles"}
              >
                <button
                  className={
                    "biwoia-copy-btn" + (copiado ? " biwoia-copy-copied" : "")
                  }
                  onClick={() => this._copiar(keyGenerada?.key)}
                >
                  {copiado ? <CheckOutlined /> : <CopyOutlined />}
                </button>
              </Tooltip>
            </div>
            <p style={{ color: "#888", fontSize: 13, marginTop: 12, marginBottom: 0 }}>
              Key creada para:{" "}
              <strong style={{ color: "#002E36" }}>{keyGenerada?.nombre}</strong>
            </p>
          </ModalItem>
        </div>
      </div>
    );
  }

  render() {
    const { showAnim, vista } = this.state;
    if (showAnim) return this.renderAnimation();
    if (vista === "claude") return this.renderClaudeConfig();
    return this.renderGrid();
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionClaude);
